import { addSentryBreadcrumb } from "src/lib/addSentryBreadcrumb";
import { isPartnerDiagnosticsEnabled } from "src/lib/partnerDiagnostics";

type Mark = { stage: string; ms: number; data?: string };

let visitStart = 0;
let marks: Mark[] = [];

export const getMarks = (): Mark[] => marks;

export const mark = (
  stage: string,
  data?: Record<string, string | number | boolean | undefined>
): void => {
  if (!isPartnerDiagnosticsEnabled()) {
    return;
  }
  const entry: Mark = {
    stage,
    ms: Math.round(performance.now() - visitStart),
    data: data ? JSON.stringify(data) : undefined
  };
  marks = [...marks, entry].slice(-50);
  addSentryBreadcrumb("learn-diagnostics", stage, "info", data);
};

export const startLearnVisit = (): void => {
  if (!isPartnerDiagnosticsEnabled()) {
    return;
  }
  visitStart = performance.now();
  marks = [];
};
